import * as React from 'react';

import { Box, Card, CardContent, Typography } from '@mui/material';

import ImageFluid from '../../legacy/components/base/ImageFluid';
import RawHtml from '../../legacy/components/base/RawHtml';

/* === COLUMN CARD PROPS ============================================================== */
export type ColumnCardVariant = 'contained' | 'flat';

interface ColumnCardProps {
  backgroundImage: any;
  description: string;
}

export interface ContainedColumnCardProps extends ColumnCardProps {
  title: string;
}

export const ContainedColumnCard = (props: ContainedColumnCardProps) => {
  /* === RENDER ======================================================================= */
  return (
    <Card sx={{ width: '100%', boxShadow: 'none', border: 'none', mx: 'auto', backgroundColor: '#F3F2F5', borderRadius: 1.75 }}>
      <CardContent>
        <Box display="flex" justifyContent="center" p={{ xs: 0, lg: 6 }} overflow="hidden">
          <img src={props.backgroundImage.src} style={{ objectFit: 'cover' }} />
        </Box>

        <Typography color="#272031" fontFamily="Gotham-Bold" fontSize={32} mt={3} mb={1.5} textAlign="center">
          {props.title}
        </Typography>

        <Typography color="#272031" fontFamily="Gotham-Book" fontSize={16} textAlign="center">
          <RawHtml content={props.description} />
        </Typography>
      </CardContent>
    </Card>
  );
};

export interface FlatColumnCardProps extends ColumnCardProps {}

export const FlatColumnCard = (props: ColumnCardProps) => {
  /* === RENDER ======================================================================= */
  return (
    <Card sx={{ width: '100%', boxShadow: 'none', border: 'none', mx: 'auto', backgroundColor: 'transparent' }}>
      <Box borderRadius="12px" overflow="hidden">
        <ImageFluid fluid={props.backgroundImage} />
      </Box>
      <CardContent>
        <Typography variant="body2" fontSize="14px" mt="1em">
          <RawHtml content={props.description} />
        </Typography>
      </CardContent>
    </Card>
  );
};
